import { Module, ActionContext } from 'vuex'
import { RootState } from '../store'

export interface CheckupsState {
  checkupFilters: string[]
}

type CheckupsActionContext = ActionContext<CheckupsState, RootState>

export default class CheckupsModule implements Module<CheckupsState, RootState> {
  state: CheckupsState

  actions: {
    filterCheckups: (context: CheckupsActionContext, by: string[]) => void
  }

  mutations: {
    filterCheckups: (state: CheckupsState, filters: string[]) => void
  }

  constructor () {
    this.state = {
      checkupFilters: []
    }

    this.mutations = {
      filterCheckups: (state, filters) => {
        state.checkupFilters = filters
      }
    }

    this.actions = {
      filterCheckups: (context, by) => {
        context.commit('filterCheckups', by)
      }
    }
  }

}
